import type { UserBasketSettingsLocationFragment, Address } from '@/generated/graphql'
import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import useTenant from '@/hooks/useTenant'
import { basketLocationToAddress } from '@caterdesk/utils--gm-validation'
import { getCountryFromLocale } from '@fusion/locale/parsing'

import { compact } from 'lodash'

export interface AddressLabelResult {
  addressLabel?: string
  showFullAddress: boolean
}

export const useAddressLabel = (
  address?: UserBasketSettingsLocationFragment | Address,
): AddressLabelResult => {
  const tenant = useTenant()
  const enabledFullAdressLabel: boolean = useFeatureFlag(SPLITS.GM_SHOW_FULL_ADDRESS)
  const country: string = getCountryFromLocale(tenant.defaultLocale)
  const basketLocationObject = address ? basketLocationToAddress(address) : undefined

  let addressLabel: string | undefined = basketLocationObject
    ? (basketLocationObject.postcode ?? basketLocationObject.street ?? undefined)
    : undefined

  const showFullAddress: boolean =
    enabledFullAdressLabel &&
    Boolean(basketLocationObject) &&
    Boolean(
      tenant.features?.gmShowFullAddress?.visibility?.regions?.includes(country.toUpperCase()),
    )

  if (showFullAddress && basketLocationObject) {
    addressLabel = compact([
      basketLocationObject.flatOrBuilding,
      basketLocationObject.floorOrBuildingName,
      basketLocationObject.street,
      basketLocationObject.city,
      basketLocationObject.postcode,
    ]).join(', ')
  }

  return { addressLabel, showFullAddress }
}
